import React from 'react'

// ExtendedCancellationPeriod هي قائمة ال
function List() {
  return (
    <ul>
     <li  style={{ textAlign: 'center' }}>Die Stornierungsfrist
beträgt 48 Stunden vor
dem Check-in.
Danach erfolgt keine
Erstattung.</li>
    </ul>
  )
}

export default List